<template>
  <div>
    <Form
      :model="searchItem"
      :label-width="150"
      label-position="left"
      :disabled="modal_loading"
      ref="formValidate"
      :show-message="false"
      style="margin-top:20px"
    >
      <Row :gutter="30">
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Employee_Number')"
            ><!-- 员工编码 -->
            <Input v-model="searchItem.empCode" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Chinese_Name')"
            ><!-- 中文姓名 -->
            <Input v-model="searchItem.userName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('BU')"
            ><!-- 业务单元 -->
            <Select v-model="searchItem.businessUnit" placeholder="" clearable>
              <Option
                v-for="item in businessUnitList"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Department')"
            ><!-- 大区 -->
            <Select v-model="searchItem.department" placeholder="" clearable>
              <Option
                v-for="item in departmentList"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Funciton')"
            ><!-- 职能 -->
            <Select v-model="searchItem.postFun" placeholder="" clearable>
              <Option
                v-for="item in functionList"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="this.$t('DepartmentSalesRegion')"
            ><!-- 部门/销售区域 -->
            <Select v-model="searchItem.salesArea" clearable>
              <Option
                v-for="item in salesAreaList"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Effective_Join_Date')"
            ><!-- 有效雇佣日 -->
            <DatePicker
              type="date"
              clearable
              v-model="searchItem.hirevalid"
              style="width:100%"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Probation_End_Date')"
            ><!-- 试用期结束日 -->
            <DatePicker
              type="date"
              clearable
              v-model="searchItem.probationEndDate"
              style="width:100%"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Line_Manager')"
            ><!-- 直线上级 -->
            <Input v-model="searchItem.dirSupUserName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Reporting_Line')"
            ><!-- 汇报层级 -->
            <Select v-model="searchItem.levelNum" multiple clearable>
              <Option
                v-for="item in Level"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6" >
          <FormItem :label="$t('PersonelType2')"
            ><!-- personneltype2 -->
            <Select v-model="searchItem.personnelType" clearable>
              <Option
                v-for="item in personnelType"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('IsNotSTIEmp')"
            ><!-- 是否有STI -->
            <Select v-model="searchItem.perresult" clearable>
              <Option
                v-for="item in YesOrNo"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem label="在职状态"
            ><!-- 在职状态 -->
            <Select v-model="searchItem.beQuit" clearable style="width:100%">
              <Option
                v-for="item in BeQuit"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="this.$t('GroupSelect')">
            <UserGroupList
              ref="UserGroupList"
              @confirmSelectGroup="confirmSelectGroup"
            ></UserGroupList>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="4">
          <Button
            type="primary"
            @click="(total = 0), (pageInfo.pageNo = 1), getData()"
            ><!-- 检索 -->{{ $t("Search") }}</Button
          >
          <Button @click="handleReset()"
            ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
          >
        </Col>
      </Row>
    </Form>
    <Table
      style="margin-top: 20px;"
      border
      :columns="columns1"
      :loading="modal_loading"
      :data="dataTable"
    >
      <template slot-scope="{ row, index }" slot="userName" style="width:100%">
        <Button type="primary" size="small" @click="showCard(row, index)">{{
          row.userName
        }}</Button>
      </template>
      <template slot="slot1" slot-scope="{ row }">
        <div>
          <Icon
            @click="openPop(1, row)"
            type="md-eye"
            style="font-size: 30px;"
            color="#459846"
          ></Icon>
        </div>
      </template>
      <template slot="slot2" slot-scope="{ row }">
        <div v-if="row.dirRoleNum > 0">
          <Icon
            @click="openPopTeam(row)"
            type="ios-people"
            style="font-size: 30px;"
            :color="row.dirRoleNum > 0 ? '#459846' : '#c7b5b5'"
          ></Icon>
        </div>
      </template>
    </Table>
    <!-- <Modal v-model="isShowDetal" :closable="false" fullscreen class="tab"
      > 人才卡片 -->
    <!--<Tabs
        type="card"
        :value="showTabDetal"
        v-model="showTabDetal"
        :animated="true"
        name="talentCard"
      >
        <TabPane
          :label="$t('PB_Talent_Card')"
          name="a"
          :index="7"
          tab="talentCard"
          v-if="isShowDetal"
          ><j2-talentCard
            ref="talentCard"
            v-if="isShowDetal"
            @back="isShowDetal = false"
          ></j2-talentCard
        ></TabPane>
      </Tabs>
      <div slot="footer">
        <Button type="text" @click="(isShowDetal = false), (showTabDetal = 'a')"
          > 返回 {{ $t("Return") }}</Button
        >
      </div>
    </Modal> -->
    <Button class="Page-style-end" :disabled="modal_loading" @click="download"
      >导出职业发展</Button
    >
    <Page
      :total="total"
      :disabled="modal_loading"
      class="Page-style"
      :current="pageInfo.pageNo"
      transfer
      :page-size="pageInfo.pageSize"
      @on-change="pageChange"
      :page-size-opts="[10, 50, 100, 150]"
      show-sizer
      @on-page-size-change="pageSizeChange"
    />
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
import UserGroupList from "../performanceManagement/components/UserGroupList.vue";
export default {
  components: { UserGroupList },
  data() {
    return {
      date: new DateUtil(),
      searchItem: {},
      modal_loading: false,
      // buod角色才能看到团队情况
      strFlag: "",
      total: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      },
      dataTable: [],
      salesAreaList: [],
      BeQuit: [],
      YesOrNo: [],
      dataList: [],
      businessUnitList: [],
      departmentList: [],
      functionList: [],
      dataListName: [],
      personnelType: [],
      Level: [],
      loading: false,
      isShowDetal: false
    };
  },
  computed: {
    columns1() {
      let arr = [
        {
          title: this.$t("Employee_Number") /* 员工编号 */,
          key: "empCode",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100,
          slot: "userName"
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.businessUnitList &&
                this.businessUnitList
                  .filter(item => params.row.businessUnit == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Department") /* 大区 */,
          key: "department",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.departmentList &&
                this.departmentList
                  .filter(item => params.row.department == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Funciton") /* 职能 */,
          key: "postFun",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.functionList &&
                this.functionList
                  .filter(item => params.row.postFun == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Effective_Join_Date") /* 有效雇佣日 */,
          key: "hirevalid",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.hirevalid, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("Probation_End_Date") /* 试用期结束日 */,
          key: "probationEndDate",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.probationEndDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupUserName",
          minWidth: 100,
          align: "center"
        },
        {
          title: this.$t("Details") /* 详情 */,
          align: "center",
          slot: "slot1",
          minWidth: 80
        }
      ];

      if (this.strFlag == "1") {
        arr.push({
          title: "团队情况" /* 详情 */,
          align: "center",
          slot: "slot2",
          minWidth: 80
        });
        return arr;
      } else {
        return arr;
      }
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  created() {
    this.getData();
    this.getListData();
  },
  methods: {
    // 新增查看团队情况 ---ljx
    openPopTeam(row) {
      const href =
        "/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27/?pageLink=name1&plan=true&empLoyeeDisabled=1&serialnumber=" +
        row.serialnumber +
        "&pagename=" +
        row.userName +
        "&tab2=1";
      window.open(href, "_blank");
    },
    confirmSelectGroup(list) {
      this.searchItem.userGroupList = JSON.parse(JSON.stringify(list));
    },
    showCard(row, index) {
      const href =
        "/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27/?id=" +
        row.serialnumber +
        "&empFlag=ABCDEF&pagename=" +
        row.userName;
      window.open(href, "_blank");

      // this.isShowDetal = true;
      // this.$nextTick(() => {
      //   this.$refs.talentCard.getData(row.serialnumber);
      //   this.$refs.talentCard.buttonShow = false;
      // });
    },
    getData() {
      this.modal_loading = true;
      this.searchItem.hirevalid
        ? (this.searchItem.hirevalid = this.date.dateVal(
            this.searchItem.hirevalid,
            "YYYY-MM-DD"
          ))
        : "";
      this.searchItem.probationEndDate
        ? (this.searchItem.probationEndDate = this.date.dateVal(
            this.searchItem.probationEndDate,
            "YYYY-MM-DD"
          ))
        : "";
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        ...this.pageInfo
      };
      axios.post("/employeeFiles/selectEmployeeFiles", obj).then(res => {
        this.modal_loading = false;
        if (res) {
          this.dataTable = res.data;
          this.strFlag = res.strFlag;
          this.total = parseInt(res.pageInfo.total);
        }
      });
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.businessUnitList = res.businessUnitList;
          this.departmentList = res.departmentList;
          this.salesAreaList = res.salesAreaList;
          this.BeQuit = res.BeQuit;
          this.YesOrNo = res.YesOrNo;
          this.functionList = res.functionList;
          this.Level = res.Level;
          this.personnelType = res.personnelType;
        }
      });
    },
    openPop(i, row) {
      const href =
        "/E97C32785C9AE390D144654FAD9065F232F121EF19EC8484/A3FFBEBFDB713E27/?id=" +
        row.serialnumber +
        "&empFlag=ABCDEF&pagename=" +
        row.userName;
      window.open(href, "_blank");
      // this.$router.push({ path: '/E97C32785C9AE390D144654FAD9065F232F121EF19EC8484/A3FFBEBFDB713E27', query: { id: row.serialnumber } })
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    async download() {
      this.modal_loading = true;
      this.searchItem.hirevalid
        ? (this.searchItem.hirevalid = this.date.dateVal(
            this.searchItem.hirevalid,
            "YYYY-MM-DD"
          ))
        : "";
      this.searchItem.probationEndDate
        ? (this.searchItem.probationEndDate = this.date.dateVal(
            this.searchItem.probationEndDate,
            "YYYY-MM-DD"
          ))
        : "";
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 9999999
      };
      // await axios.post("/userListRole/selectUserListColumnSetData", obj).then((res) => {
      //   if (res) {
      //     res.tableData.data.data.forEach(el => {
      //       arr.push({serialnumber:el.serialnumber})
      //     })
      //   }
      // })

      await axios({
        url: "/employeeFiles/exportCarlsbergEmpExcel",
        method: "post",
        data: obj,
        responseType: "blob"
      })
        .then(res => {
          var A = this.$store.getters.pageData.axiosHeader[
            "content-disposition"
          ].split("filename=")[1];
          var FileSaver = require("file-saver");
          FileSaver.saveAs(new Blob([res]), decodeURIComponent(A));
          this.loading = false;
          this.modal_loading = false;
        })
      // axios.post("/empInfo/eportEmpExcel",arr).then((res) => {
      //     var A = this.$store.getters.pageData.axiosHeader['content-disposition'].split('fileaame=')[1]
      //     console.log(A)
      //     // var A = '员工档案'
      //     var FileSaver = require('file-saver')
      //     FileSaver.saveAs(new Blob([res]), decodeURIComponent(A)+'.xls')
      // })
    },
    handleReset() {
      this.searchItem = {};
      this.$refs.UserGroupList.selectModalGroupList = [];
      this.$refs.UserGroupList.formItem.userGroupList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.ivu-modal-body {
  max-height: calc(100vh - 200px - 51px);
  overflow-y: auto;
}
.Page-style {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.Page-style-end {
  float: right;
  margin-top: 10px;
}

.tab {
  zoom: 1.1;
  height: 100vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/CarlsbergEmpTable.vue